/**
 * @author PoornaChandu
 * @description This Component is mainly for Creating Jobplans and Task and added FieldDataType
 * @View Table with crud operations of Jobplanes
 */
import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import dayjs from 'dayjs';
import {
  Form,
  Collapse,
  Popconfirm,
  Select,
  Divider,
  Space,
  Button,
  Checkbox,
  Col,
  Tabs
} from 'antd';
import {
  Toolsform,
  LaborForm,
  MaterialForm,
  ItemForm,
  FieldDataType
} from './FieldDataMeasurementJobplanes';
import { DeleteOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import {
  getTaskListByEquipmentandTaskType,
  getTaskByIdFDM,
  getSkillTypeList,
  filterTaskByReference
} from '../../../Utils/FormCalls';
import translation from '../../../../../commons/translation';
import { constant } from '../../../Utils/constants';
import { connect } from 'react-redux';

import InputComponent from '../../../Widgets/InputComponent';
import Tooltip from 'antd/es/tooltip';
import { StyledBox } from '../../../CSS/style';
const   StyledButton  = Button;
const { Panel } = Collapse;
const { Option } = Select;
const { TabPane } = Tabs;
const  StyledTabs  = Tabs;
const   StyledForm  = Form;
const WorkOrderJobPlanes = (props) => {
  const [fileUploadList, setFileUploadList] = useState({});
  const [addTask, setAddTask] = useState(false);
  const [Include, setInclude] = useState(true);
  const [SkillTypeList, setSkillTypeList] = useState([]);
  const [recordData, setRecordData] = useState(props.formObject?.TaskData || []);
  const [formObject, setFormObject] = useState(
    props.formObject && Object.keys(props.formObject).length > 0 ? props.formObject : {}
  );
  const [fileData, setFileData] = useState(props.fileData || []);
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  const [selectedTab, setSelectedTab] = useState('1');
  const [TaskList, setTaskList] = useState([]);
  const [addField, setAddField] = useState(false);
  const [actual, setActual] = useState(false);
  const [index, setIndex] = useState('');

  const [selectedTask, setSelectedTask] = useState([]);
  const workOrderJobPlanRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
     
      try {
        const skillTypeListResponse = await getSkillTypeList();
        setSkillTypeList(skillTypeListResponse);
      } catch (error) {
        // message.warn(`${error.message}`);
      }
      try {
        const taskListResponse = await getTaskListByEquipmentandTaskType(
          'Active',
          props.formObject.DeviceAlias
        );
        const filteredTaskList = filterTaskByReference(taskListResponse, recordData);
        setTaskList(filteredTaskList);
      } catch (error) {
        // message.warn(`${error.message}`);
      }
      
    };
    fetchData();
  }, [props.formObject, recordData]);
  useEffect(() => {
    if (
      props.formObject &&
      Object.keys(props.formObject).length === 0 &&
      Object.keys(formObject).length === 0
    ) {
      // onReset();
    }
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
    if (props.fileUploadList !== fileUploadList) {
      setFileUploadList(props.fileUploadList);
    }
    if (props.formObject && Object.keys(props.formObject).length === 0) {
      if (workOrderJobPlanRef && workOrderJobPlanRef.current) {
        workOrderJobPlanRef && workOrderJobPlanRef.current.setFieldsValue(props.formObject);
      }
    }
    if (props.formObject !== formObject) {
      if (workOrderJobPlanRef && workOrderJobPlanRef.current) {
        workOrderJobPlanRef && workOrderJobPlanRef.current.setFieldsValue(props.formObject);
      }
      setFormObject(props.formObject);
      setRecordData(props.formObject?.TaskData || []);
      // setWorkOrderStatus(props.workOrderStatus || null);
      setFileData(props.fileData || null);
    }
  }, [props, fileUploadList, formObject, translationCache]);

  // const handleChange = (value, key) => {
  //  let FormObject = {
  //     ...formObject,
  //     [key]: value
  //   };
  //   setFormObject(FormObject);
  // };
  // const onReset = () => {
  //   workOrderJobPlanRef && workOrderJobPlanRef.current.resetFields();
  // };
  const TaskOnChange = async (value) => {
    let TaskData = await getTaskByIdFDM(value, 'withoutId');
    let data = workOrderJobPlanRef.current.getFieldsValue() && workOrderJobPlanRef.current.getFieldsValue().TaskData || [];
    _.cloneDeepWith(TaskData, (value) => {
      return value !== undefined && value !== null
        ? {
            ...value,
            ...(value['StartTime']
              ? (value['StartTime'] = dayjs.utc(value.StartTime, 'YYYY-MM-DD HH:mm:ss'))
              : null),
            ...(value['EndTime']
              ? (value['EndTime'] = dayjs.utc(value.EndTime, 'YYYY-MM-DD HH:mm:ss'))
              : null),
            ...(value['EstimatedDuration']
              ? (value['EstimatedDuration'] = dayjs.utc(
                  value.EstimatedDuration,
                  'YYYY-MM-DD HH:mm:ss'
                ))
              : null)
          }
        : _.noop();
    });
    data.push(TaskData);
    
    let  updatedFormObject = {
      ...workOrderJobPlanRef.current.getFieldsValue(),
      TaskData: data
    };
    setSelectedTask(value);
    workOrderJobPlanRef.current.setFieldsValue(updatedFormObject);
    // setFormObject(updatedFormObject);
  };
  
  const actualTaskOnChange = async (value) => {
    let TaskData = await getTaskByIdFDM(value, 'withoutId');
    let data = workOrderJobPlanRef.current.getFieldsValue()?.ActualTaskData || [];
    _.cloneDeepWith(TaskData, (value) => {
      return value !== undefined && value !== null
        ? {
            ...value,
            ...(value['StartTime']
              ? (value['StartTime'] = dayjs.utc(value.StartTime, 'YYYY-MM-DD HH:mm:ss'))
              : null),
            ...(value['EndTime']
              ? (value['EndTime'] = dayjs.utc(value.EndTime, 'YYYY-MM-DD HH:mm:ss'))
              : null),
            ...(value['EstimatedDuration']
              ? (value['EstimatedDuration'] = dayjs.utc(
                  value.EstimatedDuration,
                  'YYYY-MM-DD HH:mm:ss'
                ))
              : null)
          }
        : _.noop();
    });
    data.push(TaskData);
    let updatedFormObject = {
      ...workOrderJobPlanRef.current.getFieldsValue(),
      ActualTaskData: data
    };
    // setFormObject(updatedFormObject);
    setSelectedTask(value);
    workOrderJobPlanRef.current.setFieldsValue(updatedFormObject);
  };

  const handleSelect = (value, mainIndex, subindex, keyName, selectedObject) => {
    
    if (keyName === 'Labor') {
      const skill =SkillTypeList && Array.isArray(SkillTypeList) && SkillTypeList.filter(item => item.Id === selectedObject[0]['SkillTypeId']);
      const list = workOrderJobPlanRef.current.getFieldValue('TaskData');
      const TaskData = [...list]; 

      TaskData.forEach((item, index) => {
        if (index === mainIndex) {
          item[keyName][subindex]['SkillTypeId'] =
            skill && skill[0] && Array.isArray(skill) && skill[0].Id ? skill[0].Id : null;
          item[keyName][subindex]['AvailableQuantity'] = selectedObject[0]['AvailableQuantity'];
        }
      });

      workOrderJobPlanRef.current.setFieldsValue({ TaskData });
    } else {
      const formObject = workOrderJobPlanRef.current.getFieldValue();
      const TaskData = formObject && formObject.TaskData;

      TaskData.forEach((item, index) => {
        if (index === mainIndex) {
          item[keyName][subindex]['Description'] = selectedObject[0]['Description'];
          item[keyName][subindex]['AvailableQuantity'] = selectedObject[0]['AvailableQuantity'];
        }
      });
      workOrderJobPlanRef.current.setFieldsValue({ TaskData });
    }
  };
  const handleSelectActual = (value, mainIndex, subindex, keyName, selectedObject) => {
    let updatedActualTaskData = workOrderJobPlanRef.current.getFieldValue('ActualTaskData');
    if (keyName === 'Labor') {
      let skill = SkillTypeList && Array.isArray(SkillTypeList) && SkillTypeList.find((item) => item.Id === selectedObject[0]['SkillTypeId']);
      updatedActualTaskData[mainIndex][keyName][subindex]['SkillTypeId'] = skill ? skill.Id : null;
      updatedActualTaskData[mainIndex][keyName][subindex]['AvailableQuantity'] =
        selectedObject[0]['AvailableQuantity'];
    } else {
      updatedActualTaskData[mainIndex][keyName][subindex]['Description'] =
        selectedObject[0]['Description'];
      updatedActualTaskData[mainIndex][keyName][subindex]['AvailableQuantity'] =
        selectedObject[0]['AvailableQuantity'];
    }
    // setFormObject((prev) => ({ ...prev, ActualTaskData: updatedActualTaskData }));
    workOrderJobPlanRef.current.setFieldsValue({ ActualTaskData: updatedActualTaskData });
  };
  const remove = (taskIndex, toolIndex, key, taskType) => {
    let updatedFormObject = workOrderJobPlanRef.current.getFieldsValue();
    let ToolsList = updatedFormObject[taskType]?.[taskIndex]?.[key];
    if (ToolsList) {
      let Tools = ToolsList.filter((_, index) => toolIndex !== index);
      updatedFormObject[taskType] = updatedFormObject[taskType].map((tasks, index) => {
        if (index === taskIndex) {
          return { ...tasks, [key]: Tools };
        }
        return tasks;
      });
      // setFormObject(updatedFormObject);
      workOrderJobPlanRef.current.setFieldsValue(updatedFormObject);
    }
  };
  // const add = (taskIndex, key) => {
  //   props.noJobplan();
  //   let currentFormObject = workOrderJobPlanRef.current.getFieldsValue();
  //   currentFormObject = {
  //     ...currentFormObject,
  //     TaskData: currentFormObject.TaskData && Array.isArray(currentFormObject.TaskData)
  //       ? currentFormObject.TaskData.map((task, index) => {
  //           if (index === taskIndex) {
  //             let reqArray = task[key] ? task[key] : [];
  //             reqArray.push(null); // Add a new empty object
  //             return { ...task, [key]: reqArray };
  //           }
  //           return task;
  //         })
  //       : [],
  //   };
  //   workOrderJobPlanRef.current.setFieldsValue(currentFormObject);
  //   setFormObject(currentFormObject);
  // };
  const addActual = (taskIndex, key) => {
    props.noJobplan();
    let currentFormObject = workOrderJobPlanRef.current.getFieldsValue();
    currentFormObject = {
      ...currentFormObject,
      ActualTaskData:
        currentFormObject.ActualTaskData && Array.isArray(currentFormObject.ActualTaskData)
          ? currentFormObject.ActualTaskData.map((task, index) => {
              if (index === taskIndex) {
                let reqArray = task[key] ? task[key] : [];
                reqArray.push(null); // Add a new empty object
                return { ...task, [key]: reqArray };
              }
              return task;
            })
          : []
    };
    workOrderJobPlanRef.current.setFieldsValue(currentFormObject);
    // setFormObject(currentFormObject);
  };
  
  const removeTask = (key, tab) => {
    let currentFormObject = workOrderJobPlanRef.current.getFieldValue();
    if (tab === 'ActualTaskData') {
      currentFormObject = {
        ...currentFormObject,
        ActualTaskData: currentFormObject.ActualTaskData
          ? currentFormObject.ActualTaskData.filter((task, index) => index !== key)
          : []
      };
    } else {
      currentFormObject = {
        ...currentFormObject,
        TaskData: currentFormObject.TaskData
          ? currentFormObject.TaskData.filter((task, index) => index !== key)
          : []
      };
    }
    workOrderJobPlanRef.current.setFieldsValue(currentFormObject);
  };
  /* eslint-disable no-template-curly-in-string */
  const validateMessages = {
    required: '${label} is required!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!'
    },
    number: {
      range: '${label} must be between ${min} and ${max}'
    },
    pattern: {
      mismatch: '${label} does not match pattern'
    }
  };
  const styledCollapse = (formObject, key, translationCache) => {
    return (
      <span>
        <span style={{ fontWeight: 'bold' }}>{translation(translationCache, 'Task Name')}</span>:
        <span style={{ color: 'white', margin: '0px 8px' }}>
          {formObject &&
          formObject['TaskData'] &&
          formObject['TaskData'][key] &&
          formObject['TaskData'][key]['TaskName']
            ? formObject['TaskData'][key]['TaskName']
            : ''}
        </span>
        <span style={{ fontWeight: 'bold' }}>
          {translation(translationCache, 'Task Description')}
        </span>{' '}
        :
        <span style={{ color: 'white', margin: '0px 8px' }}>
          {formObject &&
          formObject['TaskData'] &&
          formObject['TaskData'][key] &&
          formObject['TaskData'][key]['TaskDescription']
            ? formObject['TaskData'][key]['TaskDescription']
            : ''}
        </span>
      </span>
    );
  };
  const styledCollapseActual = (formObject, key, translationCache) => {
    return (
      <span>
        <span style={{ fontWeight: 'bold' }}>{translation(translationCache, 'Task Name')}</span>:
        <span style={{ color: 'white', margin: '0px 8px' }}>
          {formObject &&
          formObject['ActualTaskData'] &&
          formObject['ActualTaskData'][key] &&
          formObject['ActualTaskData'][key]['TaskName']
            ? formObject['ActualTaskData'][key]['TaskName']
            : ''}
        </span>
        <span style={{ fontWeight: 'bold' }}>
          {translation(translationCache, 'Task Description')}
        </span>{' '}
        :
        <span style={{ color: 'white', margin: '0px 8px' }}>
          {formObject &&
          formObject['ActualTaskData'] &&
          formObject['ActualTaskData'][key] &&
          formObject['ActualTaskData'][key]['TaskDescription']
            ? formObject['ActualTaskData'][key]['TaskDescription']
            : ''}
        </span>
      </span>
    );
  };
  return (
    <div>
      <>
        <StyledForm
          ref={workOrderJobPlanRef}
          name={'JobPlan'}
          onFinish={(values) => props.dataF(values, 'JobPlan', fileData)}
          initialValues={formObject}
          layout="vertical"
          validateMessages={validateMessages}
        >
       
          <StyledTabs
            defaultActiveKey="1"
            type="card"
            size={'middle'}
            onChange={(key) => {
              if (key === '1') {
                setSelectedTab(key);
              } else if (key === '2') {
                setSelectedTab(key);
              }
            }}
          >
            <TabPane tab={translation(translationCache, 'Planned Task')} key="1">
              <Form.List initialValue={formObject?.TaskData || []} name="TaskData">
                {(fields, { add, remove }) => (
                  <>
                    <StyledBox>
                      <Form.Item                        
                        label={translation(translationCache, constant.addTask)}
                        name="TaskName"
                      >
                        <Select
                          placeholder={translation(translationCache, 'Select Task')}
                          value={selectedTask}
                          onChange={TaskOnChange}
                          style={{ width: '100%' }}
                          dropdownRender={(menu) => {
                            return (
                              <>
                                {menu}
                                <Divider style={{ margin: '8px 0' }} />
                                <Space style={{ padding: '0 8px 4px' }}>
                                  <Button
                                    type="dashed"
                                    onClick={() => {
                                      add();
                                      setAddTask(true);
                                      setInclude(false);
                                    }}
                                  >
                                    {translation(translationCache, constant.addNewTask)}
                                  </Button>
                                </Space>
                              </>
                            );
                          }}
                        >
                          {TaskList && TaskList.map((task, index) => (
                            <Option
                              key={index}
                              value={task.Id}
                              disabled={workOrderJobPlanRef.current
                                ?.getFieldsValue()
                                .TaskData?.some((item) => item?.TaskName === task.TaskName)}
                            >
                              {task.TaskName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </StyledBox>
                    {fields.length > 0 && (
                      <Collapse
                        
                        accordion
                        defaultActiveKey={[]}
                        onChange={(e) => setIndex(e)}
                      >
                        {fields.map(({ key, name, ...restField }) => {
                          if (
                            formObject &&formObject.TaskData &&
                            Array.isArray(formObject.TaskData) &&
                            formObject.TaskData.length <= name
                          ) {
                            setAddField(formObject.TaskData.length <= name);
                          } else {
                            setAddField(false);
                          }

                          return (
                            <Panel
                              key={key}
                              header={styledCollapse(formObject, key, translationCache)}
                              extra={
                                <Popconfirm
                                  title={translation(
                                    translationCache,
                                    constant.areYouSureThatYouWantToDeleteTheTask
                                  )}
                                  icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                                  onConfirm={() => removeTask(key, 'TaskData')}
                                  okText="Yes"
                                  cancelText="No"
                                >
                                  <Tooltip
                                    title={translation(translationCache, 'Delete')}
                                    placement="bottom"
                                  >
                                    <DeleteOutlined />
                                  </Tooltip>
                                </Popconfirm>
                              }
                            >
                              <div>
                                <div>
                                  {formObject && formObject.TaskData && formObject.TaskData.length <= name && addField && (
                                    <StyledBox>
                                      <Form.Item
                                        
                                        label={translation(translationCache, constant.task)}
                                        {...restField}
                                        name={[name, 'TaskName']}
                                        rules={[{ required: true }]}
                                      >
                                        <InputComponent
                                          placeholder={translation(translationCache, 'Enter Task')}
                                          style={{ width: '100%' }}
                                        />
                                      </Form.Item>
                                      <Form.Item
                                        
                                        label={translation(
                                          translationCache,
                                          constant.taskDescription
                                        )}
                                        {...restField}
                                        name={[name, 'TaskDescription']}
                                        rules={[{ required: true }]}
                                      >
                                        <InputComponent
                                          placeholder={translation(
                                            translationCache,
                                            'Enter Task Description'
                                          )}
                                          style={{ width: '100%' }}
                                        />
                                      </Form.Item>
                                      <Form.Item
                                        style={{ marginLeft: '110px' }}
                                        name={[name, 'AddJobplan']}
                                        valuePropName="checked"
                                      >
                                        <Checkbox>
                                          {translation(translationCache, 'Include in JobPlan')}
                                        </Checkbox>
                                      </Form.Item>
                                    </StyledBox>
                                  )}
                                  <StyledTabs
                                    defaultActiveKey="1"
                                    type="card"
                                    size={'middle'}
                                  >
                                    <TabPane
                                      tab={translation(translationCache, constant.tool)}
                                      key="1"
                                    >
                                      <Col span={24}>
                                        <Form.Item>
                                          <Toolsform
                                            fieldKey={name}
                                            formObject={
                                              workOrderJobPlanRef.current !== null
                                                ? workOrderJobPlanRef.current.getFieldsValue()
                                                : {}
                                            }
                                            onToolChange={handleSelect}
                                            onRemove={remove}
                                            taskType={'TaskData'}
                                            onAdd={add}
                                            selectedTab={selectedTab}
                                          />
                                        </Form.Item>
                                      </Col>
                                    </TabPane>
                                    <TabPane
                                      tab={translation(translationCache, constant.labor)}
                                      key="2"
                                    >
                                      <Col span={24}>
                                        <Form.Item>
                                          <LaborForm
                                            fieldKey={name}
                                            formObject={
                                              workOrderJobPlanRef.current !== null
                                                ? workOrderJobPlanRef.current.getFieldsValue()
                                                : {}
                                            }
                                            onAdd={add}
                                            onRemove={remove}
                                            taskType={'TaskData'}
                                            onLaborChange={handleSelect}
                                            selectedTab={selectedTab}
                                          />
                                        </Form.Item>
                                      </Col>
                                    </TabPane>
                                    <TabPane
                                      tab={translation(translationCache, constant.material)}
                                      key="3"
                                    >
                                      <Col span={24}>
                                        <Form.Item>
                                          <MaterialForm
                                            fieldKey={name}
                                            formObject={
                                              workOrderJobPlanRef.current !== null
                                                ? workOrderJobPlanRef.current.getFieldsValue()
                                                : {}
                                            }
                                            onAdd={add}
                                            onMaterialChange={handleSelect}
                                            onRemove={remove}
                                            taskType={'TaskData'}
                                            selectedTab={selectedTab}
                                          />
                                        </Form.Item>
                                      </Col>
                                    </TabPane>
                                    <TabPane
                                      tab={translation(translationCache, constant.items)}
                                      key="4"
                                    >
                                      <Col span={24}>
                                        <Form.Item>
                                          <ItemForm
                                            fieldKey={name}
                                            formObject={
                                              workOrderJobPlanRef.current !== null
                                                ? workOrderJobPlanRef.current.getFieldsValue()
                                                : {}
                                            }
                                            onAdd={add}
                                            onRemove={remove}
                                            taskType={'TaskData'}
                                            onItemChange={handleSelect}
                                            selectedTab={selectedTab}
                                          />
                                        </Form.Item>
                                      </Col>
                                    </TabPane>
                                    <TabPane
                                      tab={translation(translationCache, 'Field Data Type')}
                                      key="5"
                                    >
                                      <Col span={24}>
                                        <Form.Item>
                                          <FieldDataType
                                            fieldKey={name}
                                            formObject={
                                              workOrderJobPlanRef.current !== null
                                                ? workOrderJobPlanRef.current.getFieldsValue()
                                                : {}
                                            }
                                            // workOrderJobPlanRef ={workOrderJobPlanRef}
                                            jobplan={addField}
                                            checkbox={index}
                                            onAdd={add}
                                            Include={Include}
                                            AddTask={addTask}
                                            onRemove={remove}
                                            taskType={'TaskData'}
                                            onFieldChange={handleSelect}
                                            selectedTab={selectedTab}
                                            // onFieldChange={handleSelect}
                                            // formHeader={formHeader}
                                          />
                                        </Form.Item>
                                      </Col>
                                    </TabPane>
                                  </StyledTabs>
                                </div>
                              </div>
                            </Panel>
                          );
                        })}
                      </Collapse>
                    )}
                  </>
                )}
              </Form.List>
            </TabPane>
            <TabPane tab={translation(translationCache, 'Actual Task')} key="2">
              <Form.List
                initialValue={
                  formObject && formObject['ActualTaskData'] ? formObject['ActualTaskData'] : []
                }
                name="ActualTaskData"
              >
                {(fields, { add }) => (
                  <>
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                      <Form.Item
                        
                        label={translation(translationCache, constant.addTask)}
                        name="TaskName1"
                      >
                        <Select
                          placeholder={translation(translationCache, 'Select Task')}
                          defaultValue={selectedTask}
                          onChange={(value) => actualTaskOnChange(value)}
                          style={{ width: '100%' }}
                          dropdownRender={(menu) => (
                            <>
                              {menu}
                              <Divider
                                style={{
                                  margin: '8px 0'
                                }}
                              />
                              <Space
                                style={{
                                  padding: '0 8px 4px'
                                }}
                              >
                                <Button
                                  type="dashed"
                                  // onClick={() => setState({ viewEquipmentModal: true })}
                                  onClick={() => add()}
                                >
                                  {' '}
                                  {translation(translationCache, constant.addNewTask)}{' '}
                                </Button>
                              </Space>
                            </>
                          )}
                        >
                          {TaskList &&
                            Array.isArray(TaskList) &&
                            TaskList.map((task, index) => {
                              return (
                                <Option
                                  key={index}
                                  value={task.Id}
                                  disabled={
                                    workOrderJobPlanRef.current &&
                                    workOrderJobPlanRef.current.getFieldsValue() &&
                                    workOrderJobPlanRef.current.getFieldsValue().ActualTaskData &&
                                    workOrderJobPlanRef.current
                                      .getFieldsValue()
                                      .ActualTaskData.filter(
                                        (item) =>
                                          item &&
                                          item !== undefined &&
                                          item.TaskName === task.TaskName
                                      ).length > 0
                                      ? true
                                      : false
                                  }
                                >
                                  {task.TaskName}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                      <Form.Item >
                        <InputComponent style={{ display: 'none' }} />
                      </Form.Item>
                    </div>
                    {fields && Array.isArray(fields) && fields.length > 0 ? (
                      <Collapse  accordion defaultActiveKey={[]}>
                        {fields.map(({ key, name ,...restField}) => {                          
                          if (
                            formObject &&formObject.ActualTaskData &&
                            Array.isArray(formObject.ActualTaskData) &&
                            formObject.ActualTaskData.length <= name
                          ) {
                            setActual(formObject.ActualTaskData.length <= name);
                          } else {
                            setActual(false);
                          }
                          return(
                          <Panel
                            key={key}
                            header={styledCollapseActual(formObject, key, translationCache)}
                            extra={
                              <Popconfirm
                                title={translation(
                                  translationCache,
                                  constant.areYouSureThatYouWantToDeleteTheTask
                                )}
                                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                                onConfirm={() => removeTask(key, 'ActualTaskData')}
                                okText="Yes"
                                cancelText="No"
                              >
                                <Tooltip
                                  title={translation(translationCache, 'Delete')}
                                  placement="bottom"
                                >
                                  <DeleteOutlined />
                                </Tooltip>
                              </Popconfirm>
                            }
                          >
                            <div>
                              <div  style={{ padding: '0px' }}>
                              {formObject && formObject.ActualTaskData && formObject.ActualTaskData.length <= name && actual && (
                                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                      <Form.Item
                                        
                                        label={translation(translationCache, constant.task)}
                                        {...restField}
                                        name={[name, 'TaskName']}
                                        rules={[{ required: true }]}
                                      >
                                        <InputComponent
                                          placeholder={translation(translationCache, 'Enter Task')}
                                          style={{ width: '100%' }}
                                        />
                                      </Form.Item>
                                      <Form.Item
                                        
                                        label={translation(
                                          translationCache,
                                          constant.taskDescription
                                        )}
                                        {...restField}
                                        name={[name, 'TaskDescription']}
                                        rules={[{ required: true }]}
                                      >
                                        <InputComponent
                                          placeholder={translation(
                                            translationCache,
                                            'Enter Task Description'
                                          )}
                                          style={{ width: '100%' }}
                                        />
                                      </Form.Item>
                                      <Form.Item
                                        style={{ marginLeft: '110px' }}
                                        name={[name, 'AddJobplan']}
                                        valuePropName="checked"
                                      >
                                        <Checkbox>
                                          {translation(translationCache, 'Include in JobPlan')}
                                        </Checkbox>
                                      </Form.Item>
                                    </div>
                                  )}
                                <StyledTabs
                                  
                                  // className={'cardContainer'}
                                  defaultActiveKey="1"
                                  type="card"
                                  size={'middle'}
                                >
                                  <TabPane
                                    tab={translation(translationCache, constant.tool)}
                                    key="1"
                                  >
                                    <Col span={24}>
                                      <Form.Item>
                                        <Toolsform
                                          fieldKey={name}
                                          formObject={
                                            workOrderJobPlanRef.current !== null
                                              ? workOrderJobPlanRef.current.getFieldsValue()
                                              : {}
                                          }
                                          onToolChange={handleSelectActual}
                                          onRemove={remove}
                                          taskType={'ActualTaskData'}
                                          onAdd={addActual}
                                          selectedTab={selectedTab}
                                        />
                                      </Form.Item>
                                    </Col>
                                  </TabPane>
                                  <TabPane
                                    tab={translation(translationCache, constant.labor)}
                                    key="2"
                                  >
                                    <Col span={24}>
                                      <Form.Item>
                                        <LaborForm
                                          fieldKey={name}
                                          formObject={
                                            workOrderJobPlanRef.current !== null
                                              ? workOrderJobPlanRef.current.getFieldsValue()
                                              : {}
                                          }
                                          onLaborChange={handleSelectActual}
                                          onRemove={remove}
                                          taskType={'ActualTaskData'}
                                          onAdd={addActual}
                                          selectedTab={selectedTab}
                                        />
                                      </Form.Item>
                                    </Col>
                                  </TabPane>
                                  <TabPane
                                    tab={translation(translationCache, constant.material)}
                                    key="3"
                                  >
                                    <Col span={24}>
                                      <Form.Item>
                                        <MaterialForm
                                          fieldKey={name}
                                          formObject={
                                            workOrderJobPlanRef.current !== null
                                              ? workOrderJobPlanRef.current.getFieldsValue()
                                              : {}
                                          }
                                          onMaterialChange={handleSelectActual}
                                          onRemove={remove}
                                          taskType={'ActualTaskData'}
                                          onAdd={addActual}
                                          selectedTab={selectedTab}
                                        />
                                      </Form.Item>
                                    </Col>
                                  </TabPane>
                                  <TabPane
                                    tab={translation(translationCache, constant.items)}
                                    key="4"
                                  >
                                    <Col span={24}>
                                      <Form.Item>
                                        <ItemForm
                                          fieldKey={name}
                                          formObject={
                                            workOrderJobPlanRef.current !== null
                                              ? workOrderJobPlanRef.current.getFieldsValue()
                                              : {}
                                          }
                                          onItemChange={handleSelectActual}
                                          onRemove={remove}
                                          taskType={'ActualTaskData'}
                                          onAdd={addActual}
                                          selectedTab={selectedTab}
                                        />
                                      </Form.Item>
                                    </Col>
                                  </TabPane>
                                  <TabPane
                                    tab={translation(translationCache, 'Field Data Type')}
                                    key="5"
                                  >
                                    <Col span={24}>
                                      <Form.Item name="Field">
                                        <FieldDataType
                                          fieldKey={name}
                                          formObject={
                                            workOrderJobPlanRef.current !== null
                                              ? workOrderJobPlanRef.current.getFieldsValue()
                                              : {}
                                          }
                                          // workOrderJobPlanRef ={workOrderJobPlanRef}
                                          checkbox={index}
                                          jobplan={addField}
                                          onAdd={add}
                                          Include={Include}
                                          AddTask={addTask}
                                          onRemove={remove}
                                          taskType={'ActualTaskData'}
                                          onFieldChange={handleSelect}
                                          selectedTab={selectedTab}
                                          // onFieldChange={handleSelect}
                                          // formHeader={formHeader}
                                        />
                                      </Form.Item>
                                    </Col>
                                  </TabPane>
                                  {/* <TabPane tab={translation(translationCache, 'Observation Type')} key="6">
                                        <Col span={24}>
                                          <Form.Item name="Observation">
                                            <ObservationType
                                              quantity={'6'}
                                              formObject={
                                                workOrderJobPlanRef && workOrderJobPlanRef.current !== null
                                                  ? workOrderJobPlanRef.current.getFieldsValue()
                                                  : {}
                                              }
                                              // onObservationChange={handleSelect}
                                              // formHeader={formHeader}
                                              Remove={remove}
                                            taskType={'ActualTaskData'}
                                            onAdd={addActual}
                                            selectedTab={selectedTab}
                                            />
                                          </Form.Item>
                                        </Col>
                                      </TabPane> */}
                                </StyledTabs>
                              </div>
                            </div>
                          </Panel>
                        );})}
                      </Collapse>
                    ) : null}
                  </>
                )}
              </Form.List>
            </TabPane>
          </StyledTabs>
          {/* {props.noJobplan === true ? */}
          <Form.Item style={{ display: 'flex', justifyContent: 'right' }}>
            <StyledButton
              
              style={{ marginTop: '20px', marginBottom: '-7px' }}
              onClick={() =>
                props.onFinish(workOrderJobPlanRef.current.getFieldsValue(), 'JobPlan', fileData)
              }
            >
              {translation(translationCache, constant.save)}
            </StyledButton>
          </Form.Item>
          {/* :null} */}
        </StyledForm>{' '}
      </>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache
  };
};
export default connect(mapStateToProps)(WorkOrderJobPlanes);
